// Vendor Imports
import 'bootstrap';


// Components
import './components/aos';
import './components/navbar';
import './components/plyr';
import './components/popover';
import './components/scroll';
import './components/typed';
import './components/tooltip';

import './components/contact';     // 新增：导入联系表单逻辑

/* place any misc js that isn't its own component in here */
import './misc';
